// extracted by css-extract-rspack-plugin
export default {"root":"Hcq1G"};